export enum MonkeyMode {
  OFF = "off",
  SPECIAL = "special",
  FULL = "full"
}
